import { apiSlice } from '../api/apiSlice'
import { RequestProps } from '../../types'
import LeaderMenteesPlanResponse from '../../types/response/LeaderMenteesPlanResponse'

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getLeaderMenteesPlan: builder.query<LeaderMenteesPlanResponse, RequestProps>({
      query: (props: RequestProps) => ({
        url: 'leader',
        params: props,
      }),
    }),
  }),
})

export const { useGetLeaderMenteesPlanQuery } = extendedApiSlice